<template>
	<b-modal
		ref="top-son-result-details"
		size="xmd"
		hide-footer
		@hidden="handleCloseModal"
		scrollable
		no-close-on-backdrop
		no-close-on-esc
	>
		<template #modal-header>
			<div class="d-flex justify-content-between align-items-center w-100">
				<h3 class="font-weight-bolder">{{ title }}</h3>
				<div style="display: flex; gap: 0.5rem">
					<b-button variant="danger" @click="handleCloseModal" v-b-tooltip.hover="'Cerrar'">
						<FeatherIcon icon="XIcon" />
					</b-button>
				</div>
			</div>
		</template>
		<b-overlay :show="isLoading">
			<!-- Mostramos las tarjetas de los hijos con resultados -->
			<div class="specimen-cards-container">
				<div class="d-flex justify-content-between mb-2">
					<div>
						Total de Hijos:
						<strong>{{ totalSons }}</strong>
					</div>
					<div>
						Total de {{ `${result === "triunfo" ? "triunfos" : "derrotas"}` }}:
						<strong>{{ totalResults }}</strong>
					</div>
				</div>
				<div v-for="(row, index) in rows" :key="index" class="mb-3">
					<b-card class="specimen-result-card" no-body>
						<div class="card-content">
							<!-- Sección superior con info y botón de toggle -->
							<div class="d-flex justify-content-between align-items-center">
								<!-- Primera sección: Información del ejemplar y pareja -->
								<div class="specimen-pair">
									<div class="specimen-info">
										<div class="type-name">Ejemplar</div>
										<SpecimenPlate :specimen="row.specimen" />
									</div>
								</div>

								<div class="specimen-pair">
									<div class="partner-info">
										<div class="type-name">
											{{ `${category_id == 1 ? "Madrilla" : "Padrillo"}` }}
										</div>
										<SpecimenPlate :specimen="category_id == 1 ? row.madrilla : row.padrillo" />
									</div>
								</div>

								<!-- Contador de resultados -->
								<div class="result-counter ml-auto mr-4">
									<div
										class="count"
										:class="{
											'text-success': result === 'triunfo',
											'text-danger': result === 'derrota',
										}"
									>
										{{ row.qty }}
									</div>
									<div class="result-label">{{ result === "triunfo" ? "Triunfos" : "Derrotas" }}</div>
								</div>

								<!-- Botón de toggle detalles -->
								<div class="details-toggle" @click="toggleDetails(index)">
									<feather-icon
										class="text-success"
										:icon="expandedRows.includes(index) ? 'ChevronUpIcon' : 'ChevronDownIcon'"
										size="24"
									/>
								</div>
							</div>

							<!-- Sección expandible con detalles -->
							<div v-if="expandedRows.includes(index)" class="expanded-details">
								<hr />
								<TournamentDetailsTable :specimen="row.specimen" :result="result" />
							</div>
						</div>
					</b-card>
				</div>
			</div>
		</b-overlay>
		<TournamentDetailsModal
			v-if="tournamentDetails.show"
			:specimen="tournamentDetails.specimen"
			@close="tournamentDetails.show = false"
		/>
	</b-modal>
</template>

<script>
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"
import SpecimenService from "@/services/specimens.service.js"
import TournamentDetailsModal from "@/views/amg/specimens/dashboard/modals/TournamentDetailsModal.vue"
import TournamentDetailsTable from "@/views/amg/specimens/components/mainDashboard/top-son-results/components/TournamentDetailsTable.vue"
export default {
	name: "TopSonResultDetails",
	props: {
		category_id: {
			required: true,
		},
		result: {
			type: String,
			required: true,
		},
		specimen: {
			type: Object,
			required: true,
		},
	},
	components: {
		SpecimenPlate,
		TournamentDetailsModal,
		TournamentDetailsTable,
	},
	data: () => ({
		filter: [],
		isBusy: false,
		reasons: [],
		modalAddVideoBySpecimen: false,
		search: "",
		isLoading: false,
		perPageOptions: [10, 25, 50],
		pagination: {
			total: 0,
			curPage: 1,
			perPage: 100,
			from: 0,
			to: 0,
		},
		tournamentDetails: {
			show: false,
			specimen: null,
		},
		rows: [],
		selectedDraft: null,
		expandedRows: [], // Controla qué filas están expandidas
	}),
	computed: {
		title() {
			return `Hijos de ${this.specimen.plate} ${this.specimen.alias ? "/" : ""} ${
				this.specimen.alias ? this.specimen.alias : ""
			} con ${this.result === "triunfo" ? "triunfos" : "derrotas"}`
		},
		fields() {
			return [
				{ key: "specimen", label: "EJEMPLAR", class: "text-start" },
				{ key: "partner", label: `${this.category_id == 1 ? "Madrilla" : "Padrillo"}`, class: "text-start" },
				{
					key: "total_incidences",
					label: `${this.result === "triunfo" ? "Triunfos" : "Derrotas"}`,
					class: "text-center",
				},
				{
					key: "details",
					label: "DETALLES",
					class: "text-center",
				},
			]
		},
		totalResults() {
			return this.rows.reduce((sum, row) => sum + row.qty, 0)
		},

		totalSons() {
			return this.rows.length
		},
	},
	methods: {
		refresh() {
			this.getRows()
		},
		handleInputSearch() {
			this.getRows()
		},
		handleCloseModal() {
			this.$emit("close")
		},
		toggleDetails(index) {
			const position = this.expandedRows.indexOf(index)
			if (position !== -1) {
				// Si ya está en el array, lo quitamos (colapsa la fila)
				this.expandedRows.splice(position, 1)
			} else {
				// Si no está en el array, lo añadimos (expande la fila)
				this.expandedRows.push(index)
			}
		},
		async getRows() {
			try {
				this.isLoading = true
				const { data } = await SpecimenService.getTopSonResultsReportDetails({
					per_page: this.pagination.perPage,
					page: this.pagination.curPage,
					category_id: this.category_id,
					result: this.result,
					specimen_id: this.specimen.id,
				})
				this.rows = data.data || []
				this.pagination.curPage = data.current_page
				this.pagination.total = data.total
				this.pagination.from = data.from
				this.pagination.to = data.to
				return this.rows
			} catch (error) {
				console.error("Error fetching rows in TopSonResultDetails:", error)
			} finally {
				this.isLoading = false
			}
		},
	},
	mounted() {
		this.$refs["top-son-result-details"].toggle()
		this.getRows()
	},
}
</script>
<style lang="scss" scoped>
.custom-card {
	border: 3px solid var(--primary);
	border-radius: 10px;
	padding: 1rem;
}
.underline-hover {
	text-decoration: underline;
	transition: all 0.1s ease;
}
.underline-hover:hover {
	font-weight: bold;
	cursor: pointer;
	font-size: 1.2rem;
}

// Estilos para las tarjetas de resultados
.specimen-cards-container {
	margin-top: 1rem;
}

.specimen-result-card {
	border: 2px solid var(--primary);
	border-radius: 15px;
	transition: all 0.3s ease;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
	overflow: hidden;

	&:hover {
		box-shadow: 0 8px 18px rgba(0, 0, 0, 0.15);
	}

	.card-content {
		padding: 1.25rem;
	}

	.specimen-pair {
		display: flex;
		align-items: center;
		flex: 1;

		.specimen-info,
		.partner-info {
			display: flex;
			flex-direction: column;
			align-items: center;

			.type-name {
				margin-bottom: 0.5rem;
				font-weight: 600;
				font-size: 0.9rem;
			}
		}

		.pair-arrow {
			margin: 0 1.5rem;
			color: var(--primary);
		}
	}

	.result-counter {
		display: flex;
		flex-direction: column;
		align-items: center;

		.count {
			font-size: 2.5rem;
			font-weight: 700;
			line-height: 1;
		}

		.result-label {
			font-size: 0.9rem;
			color: #6c757d;
			text-transform: uppercase;
			letter-spacing: 0.5px;
		}
	}

	.details-toggle {
		cursor: pointer;
		transition: all 0.2s ease;
		border-radius: 50%;
		width: 40px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;

		&:hover {
			background-color: rgba(115, 103, 240, 0.1);
		}
	}

	.expanded-details {
		animation: fadeIn 0.3s ease-in-out;
		padding-top: 0.5rem;
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(-10px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
}
</style>
